import { Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { PerformanceTrackerService  } from '../shared/services/performance-tracker.service';
import { Observable } from 'rxjs';

import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { DashboardModel } from './model/dashboard/dashboard.model';
import { DashboardService } from '../shared/services/dashboard.service';
import { LoginService } from '../services/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import {HomeService} from '../shared/services/home.service';
import { MatSidenav } from '@angular/material/sidenav';
import { NotifierService } from 'angular-notifier';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { ProjectDashboardService } from '../shared/services/project.dashboard.service';
import { StudiesService } from '../shared/services/studies.service';

interface StudyDetails{
  id:string;
  status:string;
  name:string;
  survey_uuid:string;
  survey_name:string;
}

interface ProjectDetails{
  name:string;
  id:string;
  status:string;
  org:string;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: []
})
export class DashboardComponent implements OnInit {
  @ViewChild('sidenav2', {static: false}) sidenavRef: MatSidenav;

  studies$: DashboardModel;
  status$: string;
  accessRole:any;
  studyDetails: StudyDetails;
  projectDetails:ProjectDetails;
  status_message$: string;
  showLoader: boolean;
  isCreateStudy:boolean =false;
  isUpdateStudy:boolean = false;
  isUpdateProject:boolean = false;
  isViewer:boolean = false;
  urlParams: string;
  noData: any;
  errorText: any;
  originalData:any;
  id: any;
  showMask:boolean = false;
 public accessnav:any=[];
 public checkDataLength:boolean=false;
 public selectedStudy:any;

// scroll pagination
  throttle = 150;
  scrollDistance = 1;

  pageData = {pageNo: 1, pageLimit: 30, studyMode: 'all'};
  public studiesToShow: any;

  constructor(
    public router: Router, 
    private dashboard: DashboardService, 
    private notifier: NotifierService,
    private logerror: LoginService, 
    private homeService: HomeService,
    public projectService:ProjectDashboardService,
    private stydiesService:StudiesService,
    private activatedRoute: ActivatedRoute,
    private sidePanelService:SidePanelService,
    private performanceService: PerformanceTrackerService,
  ) {
    this.showLoader = true;
    this.homeService.sidenav2Open.next(false);
    this.accessRole = JSON.parse(localStorage.getItem('access'));
    this.isViewer = this.accessRole.access_type && this.accessRole.access_type == 'viewer' ? true : false;
    // if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras &&
    //   this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.projectId) {
    //   this.urlParams = this.router.getCurrentNavigation().extras.state.projectId;
    // }
    // else {
    //   this.urlParams = 'not present';
    // }
    // this.dashboard.getStudies(this.urlParams).subscribe(data => {
    //   if (data.result.length !== 0) {
    //     this.studies$ = data;
    //     this.originalData = data;
    //     if (this.urlParams === 'not present') {
    //     this.filterData('active');
    //     }
    //     this.noData = false;
    //     this.showLoader = false;
    //   }
    //   else {
    //     this.errorText = 'There are no studies to show';
    //     this.noData = true;
    //     this.showLoader = false;
    //   }
    // },
    //   error => {
    //     if (error.status === 401 || error.status === 500) {
    //       this.errorText = 'Something went wrong';
    //       this.showLoader = false;
    //       this.noData = true;
    //     }
    //     else {
            //this.router.navigate(['homehome/access-denied']);
    //     }
    //   }
      //  err => console.log(err),
      //  () => this.showLoader = false;
    // );
  }

  ngOnInit() {
    // this.activatedRoute.params.subscribe(
    //   (param)=>{
    //     if(this.urlParams['id']){
    //       this.urlParams = this.urlParams['id'];
    //     }else{
    //       this.urlParams = 'not present'
    //     }
    //   }
    // );
    if (this.router.url.split('/')[3]) {
      this.urlParams = this.router.url.split('/')[3];
      let projIdParam = this.urlParams;
      this.urlParams = projIdParam.split('?')[0];
    }
    else {
      this.urlParams = 'not present';
    }
    // this.pageData['pageNo'] = 0;
    this.pageData['pageNo'] = 1;
    this.pageData['studyMode'] = 'all';
    this.getStudies();
    this.sidePanelService.initSideDrawer(localStorage.getItem('studyTYPE'));
    // this.sidePanelService.initSideDrawer(sessionStorage.getItem('studyTYPE'));

  }

  redirectIfItc(studyId:string){
    this.router.navigate(['/home/performance-tracker/' + studyId]);
  }

  updateAllNew(event:any){
    // this.pageData['pageNo'] = 0;
    this.pageData['pageNo'] = 1;
    if(event === true){
      this.getStudies();
    }else{
      this.sidenavRef.close();
    }
  }
  // updateProjectNew(event:any){
  //   console.log(event)
  //   if(event === true){
  //     // this.getProject();
  //   }else{
  //     this.sidenavRef.close();
  //   }
  // }

  updateDone(event:any){
    this.sidenavRef.close();
  }
  
  onCreateStudy(){
    this.sidenavRef.open();
    this.isCreateStudy = true;
    this.isUpdateStudy = false;
    this.isUpdateProject = false;
  }

  onUpdateProject(){
    this.projectService.getAProjectDetails(this.activatedRoute.snapshot.params['id'])
    this.sidenavRef.open();
    this.isCreateStudy = false;
    this.isUpdateStudy = false;
    this.isUpdateProject = true;
  }
  
  onUpdateStudy(studyDetails:any){
    this.studyDetails={
      id: studyDetails.id,
      name: studyDetails.study_name,
      status:studyDetails.study_status == 1?'1':'0',
      survey_uuid:studyDetails.survey_uuid,
      survey_name:studyDetails.survey_name
    };
    if (studyDetails.survey_uuid && studyDetails.survey_uuid != '') {
      this.stydiesService.loadsurvey('',{'isLinkedSurvey':true,'survey':{"name":studyDetails.survey_name,"uuid":studyDetails.survey_uuid}})
    }
    // console.log("this.studyDetails ====>",studyDetails)
    this.sidenavRef.open();
    this.isCreateStudy = false;
    this.isUpdateStudy = true;
    this.isUpdateProject = false;
  }

  onClose(sidenav2) {
    this.sidenavRef.toggle();
  }

  updateProject(projectDetail:any, organization:string){
    this.projectDetails = {
      id : projectDetail.id,
      name:projectDetail.name,
      status : projectDetail.project_status,
      org:organization
    };
    this.projectDetails.id = projectDetail.id;
    this.projectDetails.name = projectDetail.name;
    this.projectDetails.status = projectDetail.project_status;
    this.projectDetails.org = organization;
    this.isUpdateProject = true;
    this.sidenavRef.open();
  }

  filterData(type) {
    if (type === 'qual') {
      // this.studies$ = JSON.parse(JSON.stringify(this.originalData));
      // for ( let i = 0; i < this.studies$.result.length; ++i) {
      //   this.studies$.result = this.studies$.result.filter(item => item.study_details.type === "qual");
      // }
      this.pageData['studyMode'] = 'qual';
      this.pageData['pageNo'] = 1;
      this.getStudies();
    }
    else if(type === 'quant'){
      // this.studies$ = JSON.parse(JSON.stringify(this.originalData));
      // for ( let i = 0; i < this.studies$.result.length; ++i) {
      //   this.studies$.result = this.studies$.result.filter(item => !item.study_details.type || item.study_details.type !== "qual");
      // }
      this.pageData['studyMode'] = 'quant';
      this.pageData['pageNo'] = 1;
      this.getStudies();
    }else if (type === 'pt') {
      this.pageData['studyMode'] = 'pt';
      this.pageData['pageNo'] = 1;
      this.getStudies();
    }else{
      // this.studies$ = JSON.parse(JSON.stringify(this.originalData));
      this.pageData['studyMode'] = 'all';
      this.pageData['pageNo'] = 1;
      this.getStudies();
    }
    // if(this.studies$.result.length === 0) {
    //   this.errorText = 'There are no studies to show';
    //   this.noData = true;
    //   this.showLoader = false;
    // }
    // else {
    //   this.noData = false;
    // }
  }

  sendToProject() {
    if (this.urlParams != 'not present') {
      this.router.navigate(['/home/projects']);
    }
  }

  addRecruiter(id, study, project) {
    if(this.urlParams === 'not present') {
      this.router.navigate(['/home/dashboard', id]);
    }
    else {
      this.router.navigate(['/home/projects/dashboard', id]);
    }
    // this.router.navigate(['/home/recruiters'], { state: { studyId: id, studyName: study, projectName: project } });
  }

  // scroll pagination
  onScrollStudies() {
    this.showMask = true;
    this.pageData['pageNo']++;
    this.getStudies();
  }

  getStudies() {
    this.dashboard.getPaginationStudies(this.pageData, this.urlParams).subscribe(data => {
        if (data.result.length !=0) {
          this.studies$ = data;
          if (this.pageData['pageNo'] > 1) {
            this.studiesToShow = [...this.studiesToShow, ...this.studies$.result];
          } else {
            this.studiesToShow = this.studies$.result;
          }
          if(this.studiesToShow.length  == 1 && localStorage.getItem('isITC') == '1'){
            if(this.studiesToShow[0].study_details.id == "58ff46ac-e2f4-46c1-b1ad-9ed98ff1cbae"){
              localStorage.setItem('isITC', '0');
              this.redirectIfItc(this.studiesToShow[0].study_details.id);
            }
            this.studiesToShow
          }
          this.originalData = data;
          this.noData = false;
          this.showLoader = false;
          this.showMask = false;
        } else if (this.pageData['pageNo'] === 1) {
            this.errorText = 'There are no studies to show';
            this.noData = true;
            this.showLoader = false;
            this.showMask = false;
          } else {
          this.showMask = false;
        }
      },
      error => { // error path
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else {
          if (this.pageData['pageNo'] === 1) {
            this.errorText = 'Something went wrong';
            this.noData = true;
          }else{
            this.notifier.notify('error', 'Something went wrong');
          }
          this.showLoader = false;
          this.showMask =false;
        }
      }
    );
  }

  navigateToPerformanceTracker( studyID: string) {
    if(localStorage.getItem('access') !==null){
      const studyTYPE = ((this.selectedStudy.type && this.selectedStudy.type == "qual") ? "qual" : 'home');
      localStorage.setItem('studyTYPE', studyTYPE);
      // sessionStorage.setItem('studyTYPE', studyTYPE);
      this.sidePanelService.initSideDrawer(studyTYPE);
      this.sidePanelService.getVisibility(studyID, 'navigate');
    }
  }

  selectStudy(study){
    this.selectedStudy = study;
    if(this.selectedStudy && this.selectedStudy.type == "PT"){
      this.navigateToPtPanel(study);
    }else{
      this.navigateToPerformanceTracker(study.id);
    }
    // this.navigateToPerformanceTracker(study.id)
  }

  navigateToPtPanel(study){
    this.sidePanelService.initSideDrawer(study.type);
    this.router.navigate(['/home/product-testing/' + study.id]);
  }
}
